// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "contact",
    ENTITY_NAME: "contact",
    RESOURCE: "contacts",
};
